import React from 'react';
import { SvgIconProps } from '@mui/material';

export const BookmarkButtonIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.10202 13.9412L16.4489 21V5.70588V3.35294C16.4489 2.05345 15.3525 1 14 1H4.20409C2.85157 1 1.75513 2.05345 1.75513 3.35294V11.5882V21L9.10202 13.9412Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default BookmarkButtonIcon;
